<template>
    <div class="ui-filter-collection-dropdown">
        <div class="ui-filter-collection-dropdown--inner">
            <Button size="32" :style="'border-square'" :class="{ 'disabled': props.disabled }" @click="openSelect()">
                <svg-icon name="arrow" />
                <span>Filter</span>
            </Button>

            <div class="filter-drop" v-if="is_show_select">
                <header>
                    <h3>Filter</h3>
                    <el-button class="clear" type="text" @click="selectFilter('clear')">Clear all filters</el-button>
                </header>
                <div class="content">
                    <ul class="item-box">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in filterOneList"
                                :class="{ 'selected': main_index === v.value }" @click="toggleMain(v.value)"
                                v-show="v.show">
                                <span>{{ v.name }}</span>
                                <svg-icon name="next" v-if="v.hadSer" />
                            </li>
                        </Scrollbar>
                    </ul>

                    <ul v-if="is_show_select && main_index === 1" class="item-box sub">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in statusList" :key="k"
                                @click="selectFilter('status', v.value)" v-show="!v.not_show">
                                <svg-icon name="yes" v-if="copyParams.status === v.value" /><i v-else
                                    class="select-icon" /><span>{{ v.name }}</span>
                            </li>
                        </Scrollbar>
                    </ul>

                    <ul v-else-if="is_show_select && main_index === 2" class="item-box sub">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in typeList" :key="k" @click="selectFilter('type', v.value)">
                                <svg-icon name="yes" v-if="copyParams.type === v.value" /><i v-else
                                    class="select-icon" /><span>{{ v.name }}</span>
                            </li>
                        </Scrollbar>
                    </ul>

                    <ul v-else-if="is_show_select && main_index === 3" class="item-box sub">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in creatorStausList" :key="k"
                                @click="selectFilter('anchor_status', v.value)">
                                <svg-icon name="yes" v-if="copyParams.anchor_status === v.value" />
                                <i v-else class="select-icon" /><span>{{ v.name }}</span>
                            </li>
                        </Scrollbar>
                    </ul>

                    <ul v-else-if="is_show_select && main_index === 4" class="item-box sub">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in flagList" :key="k" @click="selectFilter('flag', v.value)">
                                <svg-icon name="yes" v-if="copyParams.flag === v.value" /><i v-else
                                    class="select-icon" /><span>{{ v.name }}</span>
                            </li>
                        </Scrollbar>
                    </ul>
                    <ul v-else-if="is_show_select && main_index === 5" class="item-box sub">
                        <Scrollbar class="scroll-inner">
                            <li class="item" v-for="(v, k) in flagList" :key="k" @click="selectFilter('flag', v.value)">
                                <svg-icon name="yes" v-if="copyParams.flag === v.value" /><i v-else
                                    class="select-icon" /><span>{{ v.name }}</span>
                            </li>
                        </Scrollbar>
                    </ul>
                </div>

                <div class="bottom">
                    <el-button type="primary" @click="selectFilter('apply')">Apply</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import Button from '@/components/ui/Button.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';
import { useRoute } from 'vue-router';
import { ElButton } from 'element-plus';

const props = defineProps({
    params: Object,
    disabled: {
        type: Boolean,
        default: false
    },
    theType: {
        type: String,
        default: 'collection',//collection,post
    },
    hide_creator: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update-filter']);

const route = useRoute();
const { statusList, typeList, flagList, creatorStausList } = useCollectionFilter();
const store = useStore();
const copyParams = ref(null);

const filterOneList = ref([
    { name: 'Post Status', value: 1, show: true, hadSer: true },
    { name: 'Post type', value: 2, show: true, hadSer: true },
    { name: 'Profile Status', value: 3, show: true, hadSer: true },
    { name: 'Flag', value: 4, show: true, hadSer: true },
]);


const is_show_select = ref(false);
// 一级菜单默认展开第一项（Collection/Post Status），filterOneList[0] 始终显示
const DEFAULT_MAIN_INDEX = 1;
const main_index = ref(DEFAULT_MAIN_INDEX);

const typeText = computed(() => {
    if (props.theType === 'collection') {
        return 'Collection';
    } else if (props.theType === 'post') {
        return 'Post';
    }
    return '';
});
const item_box_height = computed(() => {
    let sub_four = 5 * 34;
    let sub_five = 2 * 34;
    let open = main_index.value === 4 ? sub_four : main_index.value === 5 ? sub_five : 0;
    let items_height = 5 * 34 + open;
    return items_height + 18;
});


watch(() => store.state.spec_value.collection_sort_open, (val) => {
    if (val && is_show_select.value) {
        is_show_select.value = false;
    }
}, { immediate: true });

watch(() => is_show_select.value, (val) => {
    copyParams.value = JSON.parse(JSON.stringify(props.params));
});
//++++++++++++++++++++++++++++++++++++
const openSelect = () => {
    if (props.disabled) return;

    // 子菜单改为点击展开后，重新打开时不保留上次展开的子菜单，回到默认项
    if (!is_show_select.value) main_index.value = DEFAULT_MAIN_INDEX;

    is_show_select.value = !is_show_select.value;
};

// 点击一级菜单展开对应子菜单，再次点击同一项则收起
const toggleMain = (index) => {
    main_index.value = main_index.value === index ? 0 : index;
};

const selectFilter = (type, index) => {
    if (type === 'status') {
        copyParams.value.status = index;
    }
    else if (type === 'type') {
        copyParams.value.type = index;
    }
    else if (type === 'flag') {
        copyParams.value.flag = index;
    }
    else if (type === 'anchor_status') {
        copyParams.value.anchor_status = index;
    }
    else if (type === 'clear') {
        copyParams.value.status = 0;
        copyParams.value.type = 0;
        copyParams.value.flag = 0;
        copyParams.value.anchor_status= 0;
        emit('update-filter', copyParams.value);
    } else if (type === 'apply') {
        emit('update-filter', copyParams.value);
        is_show_select.value = false;
    }
};

const handleClick = (e) => {
    if (!is_show_select.value) return;
    const root_parent = document.body;
    let is_select_el = false;

    if (e.target.classList.contains('ui-filter-collection-dropdown')) {
        is_select_el = true;
    } else {
        let p = e.target.parentNode;
        while (p !== root_parent) {
            const o = p;
            if (o.parentNode) p = o.parentNode;
            else return;
            if (o.classList?.contains('ui-filter-collection-dropdown')) {
                is_select_el = true;
            }
        }
    }

    if (!is_select_el) is_show_select.value = false;
};

const startFunction = () => {
    filterOneList.value[0].name = `${typeText.value} Status`;
    filterOneList.value[1].name = `${typeText.value} Type`;
    if (props.theType === 'collection') {
        filterOneList.value[1].show = false;
    };

    if (!route.path.includes('analytics')) {
        filterOneList.value[2].show = false;
    };

    if (props.hide_creator) {
        filterOneList.value[2].show = false;
    }

    copyParams.value = JSON.parse(JSON.stringify(props.params));
}

onMounted(() => {
    startFunction();
    window.addEventListener('click', handleClick);
});

onBeforeUnmount(() => {
    window.removeEventListener('click', handleClick);
});
</script>
<style lang="scss">
.ui-filter-collection-dropdown {
    &--inner {
        position: relative;

        .ui-button {
            margin: 0 !important;
            padding: 0 10px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-color: var(--border);

            &:hover {
                border-color: var(--blue);
            }

            span {
                // margin-left: 5px;
                font: var(--font-fg-12);
                color: var(--black-60);
            }

            svg {
                width: 8px !important;
                height: 8px !important;
                margin-right: 6px !important;
                // margin-right: 5px;
                color: black !important;
            }

            &.disabled {
                border: 1px solid var(--black-10);
                cursor: not-allowed;

                span {
                    color: var(--black-40);
                }

                svg {
                    fill: var(--black-40);
                }
            }
        }


        &.hide-popup>ul,
        &.hide-popup>div {
            display: none !important;
        }

        ul {
            //min-height: 188px;
        }

        .scroll-inner {
            height: 100%;
            overflow: auto;
        }

        .item-box {
            padding: 8px 0;
            // width: 238px;
            width: 150px;

            &.sub {
                left: 150px;
                border-radius: 0 6px 6px 0;
                padding: 16px 0;

                .item>svg {
                    width: 14px;
                    height: 14px;
                    margin-right: 6px !important;
                    fill: var(--dark-blue);
                }

            }

            &.direction--right {
                right: 0px;
            }

            .item {
                padding: 9px 10px;
                display: flex;
                align-items: center;
                cursor: pointer;
                color: var(--black-60);
                font: var(--font-fg-12);

                &.sub {
                    padding-left: 20px;
                }

                span {
                    flex: 1;
                }

                &:hover,
                &.selected {
                    background: var(--bg-02);
                    color: var(--dark-blue);
                    font: var(--font-fg-12);

                    &.metric {
                        svg {
                            transform: rotate(90deg);
                        }
                    }
                }

                &.disabled {
                    color: var(--black-40);
                    cursor: not-allowed;

                    .select-icon {
                        border: 1px solid var(--black-40);
                    }
                }

                svg {
                    width: 8px;
                    height: 8px;
                    margin-right: unset !important;
                    fill: var(--dark-blue);
                }

                .select-icon {
                    width: 14px;
                    height: 14px;
                    min-width: 14px;
                    min-height: 14px;
                    margin-right: 6px;
                    border: 1px solid var(--black-50);
                    border-radius: 50%;
                    background-color: white;
                }
            }
        }
    }

    .filter-drop {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 6px 0 0 6px;
        position: absolute;
        z-index: 11;
        max-height: 40vh;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 6px 0 0 6px;
        border: 1px solid #F2F2F2;
        background: white;
        width: 300px;

        header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 4px 8px;

            .el-button {
                color: var(--blue-30);
            }

            h3 {
                font: var(--medium-16);
                flex: 1;
            }
        }

        .content {
            display: flex;
        }

        .bottom {
            padding: 4px 8px 8px;
            display: flex;
            justify-content: flex-end;
        }

        .clear span {
            color: var(--Blue-30);
        }
    }
}
</style>
